import React, { useState, useRef, useEffect } from "react";
import "../styles/HeaderFilter.css";

/*
 Filters live in the search bar. Each heading dropdown contains multiple checkbox options.
*/

const FILTERS = [
  { key: "Sort By", options: ["All", "Top Match", "Latest", "Oldest"] },
  { key: "Date Posted", options: ["All", "Past 1 hour", "Past 12 hours", "Past 24 hours", "Past 2 days", "Past 7 days"] },
  { key: "Experience", options: ["All", "Fresher (0 years)", "Entry level (1-2)", "Mid (3+)", "Internship"] },
  { key: "Job Type", options: ["All", "Internship", "Full-Time", "Part-Time", "Contract"] },
  { key: "Location", options: ["All", "Remote", "Hybrid", "Onsite"] }, // if Onsite, app may expand list of cities
];

export default function JobSearchBar({ filters, setFilters }) {
  const [open, setOpen] = useState(null);
  const wrapperRef = useRef();

  useEffect(() => {
    function handleClickOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleOption = (key, opt) => {
    setFilters((prev) => {
      const copy = { ...prev };
      // special-case searchText handled elsewhere
      const curr = copy[key] || [];
      if (opt === "All") {
        // toggle all: if All present -> clear, else set All
        if (curr.includes("All")) {
          copy[key] = [];
        } else {
          copy[key] = ["All"];
        }
      } else {
        // remove All if selecting specific
        copy[key] = curr.filter((c) => c !== "All");
        if (copy[key].includes(opt)) copy[key] = copy[key].filter((c) => c !== opt);
        else copy[key] = [...(copy[key] || []), opt];
      }
      return copy;
    });
  };

  return (
    <div className="searchbar-wrap" ref={wrapperRef}>
      <div className="search-input-area">
        <input
          className="search-input"
          placeholder="Search job title, company or skill..."
          value={filters.searchText || ""}
          onChange={(e) => setFilters((p) => ({ ...p, searchText: e.target.value }))}
        />
        <div className="filter-dropdowns">
          {FILTERS.map((f) => (
            <div key={f.key} className="filter-block">
              <button className="filter-btn" onClick={() => setOpen(open === f.key ? null : f.key)}>
                {f.key}
              </button>
              {open === f.key && (
                <div className="dropdown">
                  {f.options.map((opt) => (
                    <label className="opt-row" key={opt}>
                      <input
                        type="checkbox"
                        checked={(filters[f.key] || []).includes(opt)}
                        onChange={() => toggleOption(f.key, opt)}
                      />
                      <span>{opt}</span>
                    </label>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
        <button className="find-btn" onClick={() => setFilters((p) => ({ ...p }))}>Find Jobs</button>
      </div>
    </div>
  );
}
